import React, { useState, useEffect } from 'react'

import axios from 'axios'

import logo from '../Assets/Kabakoo.png'
import loader from '../Assets/loading.svg'


import './style.css'
import Loader from './Loader';

import CountdownTimer from '../config/Timer';
import { getLocalStorageData, handleDataStructure, urlConfiguration } from '../config/helpers';
import { main_end_point } from '../config/baseUrl'
import copyright from '../config/copyright.json'


function Verification({ componentDidMount }) {
  const [timer, setTimer] = useState({ 'is': true, 'time': '2023-09-01T17:57:30.973Z' })
  const [error, setError] = useState({ 'is': false, 'message': '' })
  const [otp, setOTP] = useState(['', '', '', '', '', '']);
  const [load, setLoad] = useState(false)
  const [loadResend, setLoadResend] = useState(false)

  const [phone, setPhone] = useState('')
  const inputRefs = [];

  const handleChange = (e, index) => {
    const value = e.target.value;

    if (value === '') {
      // L'utilisateur a effacé la valeur du champ
      otp[index] = '';
      setOTP([...otp]);

      // Si le champ précédent a une valeur, revenez automatiquement à ce champ
      if (index > 0 && otp[index - 1] !== '') {
        inputRefs[index - 1].focus();
      }
    } else if (isNaN(value) || value.length !== 1) {
      // Vérifiez si l'entrée n'est pas un seul chiffre valide
      return;
    } else {
      // Vérifiez si le champ précédent est déjà rempli
      if (index === 0 || otp[index - 1] !== '') {
        otp[index] = value;
        setOTP([...otp]);

        // Trouvez le prochain champ vide et mettez le focus dessus
        for (let i = index + 1; i < otp.length; i++) {
          if (otp[i] === '') {
            inputRefs[i].focus();
            break;
          }
        }
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoad(true)
    // Vérifiez si tous les champs sont remplis avec un seul chiffre
    if (otp.some((digit) => digit === '' || digit.length !== 1)) {
      setError({ 'is': true, 'message': copyright.verify_otp['106'] })
      setLoad(false)
      return;
    }

    // Traitez l'OTP, par exemple, envoyez-le au backend pour vérification
    let storeData = getLocalStorageData()
    let hashed_phone = storeData.kaba_info.neguediourou

    verify_otp(hashed_phone, otp.join(''))

    // Réinitialisez le formulaire
    setOTP(['', '', '', '', '', '']);
    inputRefs[0].focus();
  };

  useEffect(() => {
    let storeData = getLocalStorageData()
    let phone_number = storeData.kaba_info.phone
    setPhone(phone_number);
    let local_data_time = storeData.kaba_info.time
    local_data_time ? setTimer({ ...timer, 'time': local_data_time }) : ''
  }, [])

  const verify_otp = async (hash_phone, otp) => {
    const data = {
      'hashed_phone': hash_phone,
      'otp': otp
    };
    await axios.post(`${main_end_point}/verify_otp/`, data)
      .then((response) => {
        let type_ = response.data.type
        let type;

        let storeData = getLocalStorageData()
        let otp_id = storeData.kaba_info.one_time_password.one_time_password_id

        handleDataStructure('one_time_password_id', response.data.otp_id)
        handleDataStructure('one_time_password', otp)

        switch (type_) {
          case 'sign_in':
            type = 'signin'
            // on login l'apprenant
            handleDataStructure('one_time_passoword_type', type)
            login(hash_phone, otp_id, otp)
            break;
          case 'sign_up':
            // type = 'signup'
            handleDataStructure("signup", '')
            componentDidMount(5)

            break
          default:

            type = 'signin'
            // handleDataStructure(type, '')
            // componentDidMount(1)

            break;
        }

      })
      .catch((error) => {
        let code = error.response.data.code
        setError({ 'is': true, 'message': copyright.verify_otp[`${code}`] })
        setLoad(false)
        //  console.log(error.response);
        switch (code) {
          case 103:
            handleDataStructure("signin", '')
            componentDidMount(1)
            break;

          default:
            break;
        }
      })
  }

  const login = async (hash_phone, otp_id, otp) => {
    let storeData = getLocalStorageData()
    let device_id = storeData.kaba_info.device_id
    let source = storeData.kaba_info.source

    const data = {
      'hashed_phone': hash_phone,
      'otp_id': otp_id,
      'otp': otp
    };

    // Ajouter device_id seulement s'il existe
    if (device_id) {
      data.device_id = device_id;
    }

    await axios.post(`${main_end_point}/login/`, data)
      .then((response) => {
        // Récupérer le token directement de la réponse
        let token = response.data.token

        // Stocker le token dans le localStorage
        handleDataStructure('kabakoo.africa.token', token)
        handleDataStructure("signin", '')
        componentDidMount(1)

        // on redirige l'apprenant
        console.log(urlConfiguration(hash_phone, token, source))
        window.location.href = urlConfiguration(hash_phone, token, source)

      })
      .catch((error) => {
        let code = error.response.data.code
        setError({ 'is': true, 'message': copyright.login[`${code}`] })
      })
  }
  const resend_otp = async () => {
    setLoadResend(true)
    let storeData = getLocalStorageData().kaba_info
    let hash_phone = storeData.neguediourou
    let otp_id = storeData.one_time_password.one_time_password_id
    let otp_type = storeData.one_time_password.one_time_passoword_type

    const data = {
      'hashed_phone': hash_phone,
      'otp_id': otp_id,
      'type': otp_type
    };

    await axios.post(`${main_end_point}/resend_otp/`, data)
      .then((response) => {
        handleDataStructure('one_time_password_id', response.data.otp_id)
        handleDataStructure('one_time_password_quota_day', response.data.remaining_daily_otps)
        handleDataStructure('one_time_passoword_type', otp_type)
        handleDataStructure('time', response.data.new_delay)
        componentDidMount(4)
        window.location.reload()
      })
      .catch((error) => {
        setLoadResend(false)

        let code = error.response.data.code
        setError({ 'is': true, 'message': copyright.resend_otp[`${code}`] })
        // console.log(error.response);
        switch (code) {
          case 102:
            handleDataStructure("signin", '')
            componentDidMount(1)
            break;

          default:
            break;
        }
      })
  }

  return (
    <div>
      <div className='heading'>
        <div className="logo">
          <div className="image">
            <img src={logo} alt="logo" />
          </div>
        </div>
        <div className="title">
          <h4>{copyright.verification.titre}</h4>
          <h5>{phone}</h5>
          <p>{copyright.verification.info}</p>
          {/* <p>Nous t’avons envoyé un code à 6 chiffres par SMS pour <br /> vérifier ton numéro de téléphone. <br /> Veuillez le saisir pour finaliser la vérification. </p> */}
        </div>

      </div>
      <form onSubmit={handleSubmit}>
        <div className="input-block" id="input-block" >
          {otp.map((digit, index) => (
            <input
              style={error.is ? { border: '1px solid #E76F51' } : {}}
              key={index}
              type="tel"
              value={digit}
              onChange={(e) => handleChange(e, index)}
              ref={(input) => (inputRefs[index] = input)}
              maxLength="1" // Limitez la longueur de l'entrée à 1 caractère
            />
          ))}
        </div>
        <div className="button input-block">
          {load ? <Loader img={loader} /> : <input type="submit" value="Vérifier" />}
        </div>
        <div className="error">
          {error.is && <p>{error.message}</p>}
        </div>
      </form>
      <div className="timer" style={{ marginBottom: '20px' }}>
        {timer.is ?
          (<div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
            <CountdownTimer stopTimer={setTimer} timer={timer} />
            <button style={{ opacity: 0.4 }} disabled>Renvoyer le code</button></div>)
          : (loadResend ? <Loader img={loader} /> : <button onClick={resend_otp}>Renvoyer le code</button>)}
      </div>
    </div>
  );
}


export default Verification